import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './components.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'invert';
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  block?: boolean;
  leading?: ReactNode;
}

export function Button({
  variant = 'secondary',
  size = 'md',
  loading = false,
  block = false,
  leading,
  className = '',
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`k-btn k-btn--${variant} k-btn--${size} ${block ? 'k-btn--block' : ''} ${className}`}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="k-spinner" aria-hidden /> : leading}
      <span>{children}</span>
    </button>
  );
}
